/* Removing the website-feedback pop-up modal in favor of opening external link in new window
var $ = jQuery.noConflict();

$(document).ready( function() {

	function setCookie(cname,cvalue,exdays) {
		var d = new Date();
		d.setTime(d.getTime()+(exdays*24*60*60*1000));
		var expires = "expires="+d.toGMTString();
		document.cookie = cname + "=" + cvalue + "; " + expires;
	}

	var surveyClicked = 0;

	//remove cookie, allow surveymonkey pop-up
	setCookie('smcx_0_last_shown_at','',-1);

	//Surveymonkey.com feedback pop-up when the .website-feedback class is clicked
	$(".website-feedback").on( "click", function() {

		surveyClicked++;

		(function(t,e,s,o){var n,c,l;t.SMCX=t.SMCX||[],e.getElementById(o)||(n=e.getElementsByTagName(s),c=n[n.length-1],l=e.createElement(s),l.type="text/javascript",l.async=!0,l.id=o,l.src=["https:"===location.protocol?"https://":"http://","widget.surveymonkey.com/collect/website/js/tRaiETqnLgj758hTBazgd5Qwtp8zVs7_2BfF4TpOvbZovGZ4bR75LGlXBafcIdXi4h.js"].join(""),c.parentNode.insertBefore(l,c));})(window,document,"script","smcx-sdk");

		if(surveyClicked <= 1) {
			$('<div class="survey-backdrop" style="display:none;"></div>').appendTo("body");
			$(".survey-backdrop").fadeIn();
		}

		if(surveyClicked > 1) {
			alert("Thank you for your feedback.");
		}

		$('body').on('DOMNodeInserted', '.smcx-widget', function () {
			$(".smcx-modal-close").on( "click", function() {
				$(".survey-backdrop").fadeOut();
			});
			$(".survey-backdrop").on( "click", function() {
				$(".survey-backdrop").fadeOut();
				$(".smcx-modal-close").trigger("click");
			});
		});
    });

});
*/